import { render, staticRenderFns } from "./FormHeader.vue?vue&type=template&id=4d01a642"
import script from "./FormHeader.vue?vue&type=script&setup=true&lang=js"
export * from "./FormHeader.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports